<template>
  <div>
    <el-card v-loading="loading" style="margin-bottom: 20px">
      <div style="overflow: hidden; line-height: 36px">
        状态：{{ statusDist[detail.checklistStatus] }}
        <el-upload
          v-if="detail.checklistStatus === 'INPUT_WAIT'"
          style="float: right; margin: 0 10px"
          class="avatar-uploader"
          action="/file.api"
          accept=".xls, .xlsx"
          :show-file-list="false"
          :data="uploadData"
          :name="uploadName"
          :on-success="handleAvatarSuccess2"
        >
          <el-button type="primary">异步导入运单号</el-button>
        </el-upload>
        <el-upload
          v-if="detail.checklistStatus === 'INPUT_WAIT'"
          style="float: right; margin: 0 10px"
          class="avatar-uploader"
          action="/file.api"
          accept=".xls, .xlsx"
          :show-file-list="false"
          :data="uploadData"
          :name="uploadName"
          :on-success="handleAvatarSuccess"
        >
          <el-button type="primary">导入运单号</el-button>
        </el-upload>
        <el-button
          type="primary"
          v-on:click="exportData"
          style="float: right; margin: 0 10px"
          >导出</el-button
        >
        <el-button
          type="primary"
          v-if="detail.checklistStatus === 'INPUT_WAIT'"
          v-on:click="closeData"
          style="float: right; margin: 0 10px"
          >作废</el-button
        >
      </div>
    </el-card>

    <el-card v-loading="loading" class="pro-detail">
      <!-- 基本信息 -->

      <el-row class="info">
        <el-form label-width="80" :inline="true">
          <el-row>
            <el-col :span="24">
              <h3>基本信息</h3>
            </el-col>
            <el-col :span="8">
              <el-form-item label="核放单号：">
                {{ detail.realChecklistOrderNo || "-" }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="编号：">
                {{ detail.checklistOrderNo }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车辆信息：">
                {{ detail.licensePlate }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="快递公司：">
                {{ detail.carrierCodeDesc }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工作台号：">
                {{ orders && orders[0] && orders[0].stationNo }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <el-row>
        <el-divider></el-divider>
        <h3>托盘明细</h3>
      </el-row>
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        v-if="orders && orders.length"
      >
        <el-tab-pane
          v-for="(item, index) in orders"
          :key="index"
          :label="'托盘' + (index + 1)"
          :name="item.stationNo + index"
        >
          <el-row style="padding: 20px 0">
            <el-col style="padding: 10px 0" :span="6"
              >操作人：{{ item.operatorNo }}</el-col
            >
            <el-col style="padding: 10px 0" :span="6"
              >托盘号：{{ item.trayNo }}</el-col
            >
            <el-col style="padding: 10px 0" :span="6">
              托盘{{ index + 1 }}累计录入包裹数：{{
                item.packageTotalCount
              }}(个）
            </el-col>
            <el-col style="padding: 10px 0" :span="6">
              托盘{{ index + 1 }}累计录入包裹总毛重：{{
                item.packageTotalWeight
              }}(g）
            </el-col>
            <el-col style="padding: 10px 0" :span="6">
              托盘{{ index + 1 }}累计SKU种类总计：{{
                item.skuKindTotalCount
              }}(个）
            </el-col>
          </el-row>
          <element-table
            headerClassName="stock-table"
            :data="item.list[currentPage - 1]"
            :columns="skuListColumns"
            :loading="loading"
            border
          ></element-table>
          <el-pagination
            layout="pager"
            @current-change="paginationChange"
            :page-size="100"
            :current-page="currentPage"
            :total="
              item.customsChecklistOrderPackageDetails &&
              item.customsChecklistOrderPackageDetails.length
            "
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
      <div v-else style="line-height: 80px; text-align: center">
        <img
          src="@/static/img/no_data.png"
          style="
            display: inline-block;
            width: 30px;
            height: 30px;
            transform: translateY(10px);
            margin-right: 10px;
          "
        />
        <span style="color: #bbbbbb">暂无数据</span>
      </div>
    </el-card>

    <el-dialog title="运单号预览" :visible="visible" @close="visible = false">
      <element-table
        v-if="failInfos.length"
        headerClassName="stock-table"
        :data="failInfos"
        :columns="dialogColumns"
        :loading="loading"
        border
      ></element-table>
      <span
        style="line-height: 50px; font-size: 18px"
        v-if="failInfos.length === 0"
        >当前运单号全部校验通过</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          @click="importList"
          v-if="failInfos.length === 0"
          >导入</el-button
        >
        <el-button type="primary" @click="importList" v-if="failInfos.length"
          >继续导入</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ElementTable from "@/components/ElementTable";
import { formatDate } from "@/utils/common";
import { mapActions } from "vuex";
import { CONST_VD_IMGPREFIX } from "@/config/constant";

export default {
  data() {
    return {
      visible: false,
      dialogColumns: [
        {
          title: "商户订单号",
          key: "merchantOrderNo",
          align: "center",
        },
        {
          title: "运单号",
          key: "mailNo",
          align: "center",
        },
        {
          title: "包裹重量（克）",
          key: "packageWeight",
          align: "center",
        },
        {
          title: "错误信息",
          key: "errorMsg",
          align: "center",
        },
      ],
      Id: this.$route.params.id,
      loading: false,
      activeName: "",
      detail: {},
      statusDist: {
        INPUT_WAIT: "创建成功，待录入",
        INPUT_COMPLETED: "运单信息录入完成",
        CUSTOMS_APPROVED: "核放单关联完成",
        CLOSE: "核放单已作废",
      },
      orders: [],
      skuListColumns: [
        {
          title: "运单号",
          key: "mailNo",
          align: "center",
        },
        {
          title: "包裹总毛重（g）",
          key: "packageWeight",
          align: "center",
          render: (h, param) => {
            return <span>{param.row.packageWeight}</span>;
          },
        },
      ],
      uploadData: {
        _aid: 401,
      },
      uploadName: "CPRODUCT_IMG.xlsx",
      customsChecklistOrderItem: null,
      successInfos: [],
      failInfos: [],
      tabsIndex: 0,
      currentPage: 1,
    };
  },
  components: {
    ElementTable,
  },
  watch: {
    $route(to, from) {
      if (to.name === "checkListDetail") {
        this.Id = this.$route.params.id;
        this.fetch();
      }
    },
  },
  created() {
    this.Id = this.$route.params.id;
  },
  mounted() {
    this.Id = this.$route.params.id;
    this.fetch();
  },
  methods: {
    ...mapActions("danding", [
      "fetchNuclearReleaseDetail",
      "exportNuclearReleaseList",
      "closeNuclearRelease",
      "previewChecklistOrderMailNoImport",
      "importChecklistOrderMailNo",
      "asynSubmitMailNosImport",
    ]),
    paginationChange(currentPage) {
      this.currentPage = currentPage;
    },
    close() {
      this.visible = false;
    },
    handleClick(e) {
      this.currentPage = 1;
    },
    importList() {
      this.visible = false;
      this.loading = true;
      this.importChecklistOrderMailNo({
        request: {
          customsChecklistOrderItem: this.customsChecklistOrderItem,
          customsCheckOrderMailNoImportInfos: this.successInfos,
        },
      })
        .then((res) => {
          if (res.value) {
            this.$message.success("导入成功");
          } else {
            this.$message.warning("导入失败，请稍后重试");
          }
          this.fetch();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 异步导入运单号
    handleAvatarSuccess2(res, file) {
      this.localFilePath = file.name;
      let filUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.filUrl = filUrl;
      this.loading = true;
      this.asynSubmitMailNosImport({
        fileUrl: filUrl,
        checklistOrderNo: this.Id,
      })
        .then((res) => {
          this.loading = false;
          if (res.value) {
            this.$alert("提交成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ name: "importPreview" });
              },
            });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    // 导入运单号预览
    handleAvatarSuccess(res, file) {
      this.localFilePath = file.name;
      let filUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.filUrl = filUrl;
      this.loading = true;
      this.previewChecklistOrderMailNoImport({
        fileUrl: filUrl,
        checklistOrderNo: this.Id,
      })
        .then((res) => {
          this.loading = false;
          if (!res.customsChecklistOrderItem) {
            this.$message.error(res.errorMsg);
          } else {
            this.successInfos = res.successInfos;
            this.failInfos = res.failInfos;
            this.customsChecklistOrderItem = res.customsChecklistOrderItem;
            this.visible = true;
            if (res.errorMsg) {
              this.$message.error(res.errorMsg);
            }
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    // 导出数据
    exportData() {
      this.loading = true;
      this.exportNuclearReleaseList({
        request: {
          checklistOrderNos: [this.Id],
        },
      }).then((res) => {
        this.loading = false;
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.push({ name: "download" });
            },
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    },
    closeData(id) {
      this.$confirm("确定要将选中的核放单作废吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((res) => {
          this.loading = true;
          this.closeNuclearRelease({
            request: { customsChecklistNos: [this.Id] },
          })
            .then((res) => {
              if (res) {
                this.fetch();
              }
              this.loading = false;
            })
            .catch((err) => (this.loading = false));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cancelReturn(id) {
      this.$confirm("是否确定取消退货订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((res) => {
          let list = [this.Id];
          this.cancelGoodsReturn({
            request: { customsGoodsReturnOrderNos: list },
          }).then((res) => {
            if (res.failureList.length) {
              this.$message.warning(
                `有${res.failureList.length}条数据提交失败`
              );
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取入库单详情
    fetch() {
      this.loading = true;
      this.fetchNuclearReleaseDetail({
        checklistOrderNo: this.Id,
      })
        .then((res) => {
          this.detail = res.customsChecklistOrderItem;
          let orders = res.customsChecklistSubOrderItems;
          orders.map((item) => {
            let arr = [],
              size = 100,
              list = [];
            item.customsChecklistOrderPackageDetails.map((ite, inde) => {
              if (arr.length === size) {
                list.push(arr);
                arr = [ite];
              } else {
                arr.push(ite);
              }
            });
            if (arr.length) {
              list.push(arr);
            }
            item.list = list;
          });
          this.orders = orders;
          if (
            res.customsChecklistSubOrderItems &&
            res.customsChecklistSubOrderItems.length
          ) {
            this.activeName =
              res.customsChecklistSubOrderItems[0].stationNo + 0;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    formatDate,
  },
};
</script>

<style lang="scss">
.pro-detail {
  .info-title {
    height: 64px;
    background: #f5f5f5;
    color: #17181a;
    // font-size: 20px;
    font-weight: bold;
  }

  .info {
    padding: 10px 0 30px;

    .address {
      white-space: nowrap;

      .el-input {
        width: 33% !important;
      }
    }
  }

  .el-alert {
    margin-bottom: 10px;
  }

  .el-alert__title {
    font-size: 20px;
  }

  .el-alert__content {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .tip {
      color: #ff3333;
    }
  }
}
</style>
